import { FormControl } from '@angular/forms';
import { ApplianceDetailsFormField } from '../../models/appliance-details-stepped/forms/appliance-details-form-field.enum';
import { ApplianceDetailsForm } from '../../models/appliance-details-stepped/forms/appliance-details-form.interface';

export const mockApplianceDetailsForm: ApplianceDetailsForm = {
  [ApplianceDetailsFormField.ApplianceCategory]: new FormControl(null),
  [ApplianceDetailsFormField.ApplianceCode]: new FormControl(null),
};
